// extracted by mini-css-extract-plugin
module.exports = {"container":"_1410bfd27b--container--nbE6K","label":"_1410bfd27b--label--TStSx","title":"_1410bfd27b--title--KJuLL","button":"_1410bfd27b--button--v1t30"};